import { jsx as _jsx } from "react/jsx-runtime";
import router from 'next/router';
import { SessionProvider as NextAuthSessionProvider, useSession as useNextAuthSession, } from 'next-auth/react';
import { createContext, useEffect, useState } from 'react';
import { useBaseConfig } from '@zurich/common/contexts';
export const SessionContext = createContext({ session: null, status: 'unauthenticated', refreshInProgress: false });
function InternalSessionProvider({ children }) {
    const { data, status, update } = useNextAuthSession({ required: false });
    const { mocking } = useBaseConfig();
    const [refreshInProgress, setRefreshInProgress] = useState(false);
    const session = data;
    useEffect(() => {
        if (typeof session?.errorId === 'string' && session.errorId) {
            void router.push(`/autherror?component=token&error=${session.errorId}`);
        }
    }, [session]);
    useEffect(() => {
        if (mocking.session ||
            !session?.minimumExpiresIn ||
            session.minimumExpiresIn <= 0) {
            return;
        }
        console.debug('👨 Session timeout', session.minimumExpiresIn);
        const id = setTimeout(() => {
            async function updateSession() {
                console.debug('👨 Updating session');
                setRefreshInProgress(true);
                await update();
                setRefreshInProgress(false);
                console.debug('👨 Session was successfully updated');
            }
            void updateSession();
        }, session.minimumExpiresIn);
        return () => clearTimeout(id);
    }, [mocking.session, session?.minimumExpiresIn, update]);
    return (_jsx(SessionContext.Provider, { value: { session, status, refreshInProgress }, children: children }));
}
function MockedSessionProvider({ session, children, }) {
    return (_jsx(SessionContext.Provider, { value: {
            session,
            status: 'authenticated',
            refreshInProgress: false,
        }, children: children }));
}
export function SessionProvider({ disabled, basePath, session, children, }) {
    const { mocking } = useBaseConfig();
    if (disabled) {
        return children;
    }
    return mocking.session ? (_jsx(MockedSessionProvider, { session: session, children: children })) : (_jsx(NextAuthSessionProvider, { basePath: basePath, children: _jsx(InternalSessionProvider, { children: children }) }));
}
